import {isEmpty} from 'lodash'
import {getImageUrl, onError, message, errorHandler, logout, loader, routeErrorHandler} from '@/libs/helper'
import OrgFilter from '@/components/pages/InformationPortal/Organisation/OrgFilter/OrgFilter.vue'
import {changeCollaboratorRole, getCollaboratorsList, getMetaCollectionList, removeCollaborator, getMetaDossierList} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import {mapGetters} from 'vuex'
export default {
    name: 'TeamSettings',
    mixnins: [OrganisationRolesErrorHandlerMixin],
    components: {
        OrgFilter,
        InvitePeople: () => import("@/components/pages/InformationPortal/Organisation/InvitePeople/InvitePeople.vue")
    },
    mounted () {
        // fetch collections
        this.fetchCollections()
        // fetch dossiers
        this.fetchDossiers()
    },
    data() {
        return {
            isEmpty,
            onError,
            getImageUrl,
            manageList: {},
            showDropdown: false,
            currentPage: 1,
            skip: 0,
            limit: 30,
            sort: 'name',
            order: 'desc',
            isInvite: false,
            collaboratorList: [],
            collaboratorData: {},
            columns: ['name', 'role', 'settings'],
            tableSettings: {
                headings: {
                  name: 'Name',
                  settings: '',
                  role: 'Rights',
                },
                pagination: {show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            isChangeRole: false,
            selectedCollaboratorToUpdate: {},
            selectedCollaboratorRight: '',
            collectionList: [],
            isCollectionFetching: false,
            isLoadMoreCollections: true,
            collectionSkip: 0,
            selectedCollection: {},
            isFetchingDossiers: false,
            isLoadMoreDossiers: true,
            dossierSkip: 0,
            dossierList: [],

        }
    },
    computed: {
        isDisabledCollections () {
            return this.isFetchingCollections || !this.isLoadMoreCollections
        },
        isDisabledDossiers () {
            return this.isFetchingDossiers || !this.isLoadMoreDossiers
        },
        ...mapGetters({
            teamRoles: 'getTeamRoles'
        })
    },
    methods: {

        routeToSettingsPage () {},

        /**
         * handle command
         */
        handleCommand (option, data) {
            switch (option) {
                case 'DELETE':
                    this.deleteCollaborator(data)
                break
                case 'CHANGE_RIGHT':
                    this.isChangeRole = true
                    this.selectedCollaboratorToUpdate = data
                    this.selectedCollaboratorRight = data.role
                break
            }
        },

        /**
         * to close invite dialog
         */
        closeInviteDialog () {
            this.isInvite = false
        },

        /**
         * reset when popup is closed
         */
        closeRoleDialog () {
            this.isChangeRole = false
            this.selectedCollaboratorToUpdate = {}
            this.selectedCollaboratorRight = ''
        },

        /**
         * to change right of collaborators
         * @param {*} right 
         */
        changeCollaboratorRight (right) {
            this.selectedCollaboratorRight = this.selectedCollaboratorRight === right ? '' : right
        },

        /**
         * to update the role of collaborator
         */
        async updateCollaboratorRole () {
            try {
                loader(this, true)
            // body for api
            let body = {
                entity_type: 'COLLECTION',
                entity_id: this.selectedCollection._id,
                member: this.selectedCollaboratorToUpdate._id,
                organisation: this.$route.params.id,
                team: this.$route.params.tid
            }
            // api call
            let response = await changeCollaboratorRole(body)
            if (response.success) {
                this.collaboratorList = this.collaboratorList.map(list => {
                    if (list._id === this.selectedCollaboratorToUpdate._id) list.role = this.selectedCollaboratorRight
                    return list
                })
                message(this, constants.messageType.SUCCESS, 'Collaborator role changed successfully')
            }
            this.closeRoleDialog()
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
            loader(this, false)
        },
        /**
         * fetch Collaborators list
         */
        fetchCollaboratorsList () {
            if (isEmpty(this.selectedCollection)) return
            // body for api
            let body = {
                list_for: this.selectedCollection.type === constants.LIST.REGULAR_COLLECTION ? constants.LIST.COLLECTION : constants.LIST.DOSSIER,
                entity_type: constants.ORGANISATIONS.TEAM,
                list_id: this.selectedCollection._id,
                entity_id: this.$route.params.tid
            }
            // api call
            getCollaboratorsList(body).then(response => {
                this.collaboratorData = response || {}
                this.collaboratorList = response.items || []
            })
            .catch(error => {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            })
        },
        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // call for fetching the articles
            this.fetchCollaboratorsList()
        },
        
        /**
         * fetch collections
         */
        fetchCollections (isLoadMore) {
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.collectionSkip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: constants.ORGANISATIONS.TEAM,
                entity_id: this.$route.params.tid
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else {
                    this.collectionList = response.items || []
                    this.selectedCollection = (response.items && response.items[0]) || {}
                    this.fetchCollaboratorsList()
                }
                // increase the skip
                this.collectionSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreCollections = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch((error) => {
                console.error(error)
                this.isLoadMoreCollections = false
                this.isFetchingCollections = false
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            })
        },

        /**
         * to fetch collections 
         */
        async fetchDossiers (isLoadMore) {
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: constants.ORGANISATIONS.TEAM,
                    entity_id: this.$route.params.tid
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                console.error(error)
                this.isLoadMoreDossiers = false
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },

        /**
         * infinite loading handler
         */
        handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMoreCollections) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },

        /**
         * to switch the collection and fetch 
         * the collaboratorList on basis of 
         * current selected collection
         * @param {*} collection 
         */
        switchCollection(collection) {
            // hide the dropdown
            this.showDropdown = false
            // set collection
            this.selectedCollection = collection
            // set skip to 0
            this.skip = 0
            // fetch new list
            this.fetchCollaboratorsList()
        },
        /**
         * to delete the collaborator
         */
        deleteCollaborator (collaborator) {
            const mainTitle = `${window.i18next.t(`Remove collaborator`)} `;
            const nameTitle = `${collaborator.first_name} ${collaborator.last_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a collaborator, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the collaborator, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(async() => {
                    loader(this, true)
                    // api all
                    try {
                        let body = {
                            entity_type: 'COLLECTION',
                            entity_id: this.selectedCollection._id,
                            member: collaborator._id,
                            organisation: this.$route.params.id,
                            team: this.$route.params.tid
                        }
                        let response = await removeCollaborator(body)
                        if (response.success) {
                            this.collaboratorList = this.collaboratorList.filter(collab => collab._id !== collaborator._id)
                            message(this, constants.messageType.SUCCESS, 'Collaborator removed successfully')
                        }
                    } catch (error) {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                        // error handler for permissions
                        this.rolesErrorHandler(error, true)
                    }
                    loader(this, false)
                    
                }).catch((error) => {
                    console.error('--', error)
                })
        }
    }
}